import { Link } from 'wouter-preact'

import { Button, TextLink, Typography } from 'components/UI/atoms'

import { Modal } from '../modal'

type Props = {
	onCloseModal: () => void
}

const ExitWorkspaceModal = ({ onCloseModal }: Props) => (
	<Modal className='space-y-10 p-10' onCloseModal={onCloseModal} isOpen>
		<Typography color='text-product' text='Exit workspace' variant='h2' />

		<Typography
			color='text-black-100'
			text='Unsaved changes in the open workspace will be lost. Are you sure you want to exit?'
			variant='text1'
		/>

		<div class='flex justify-between'>
			<TextLink
				ariaLabel='Cancel'
				onClick={onCloseModal}
				text='Cancel'
				variant='secondary'
			/>
			<Link href='~/'>
				<Button text='Exit workspace' variant='error' />
			</Link>
		</div>
	</Modal>
)

export { ExitWorkspaceModal }
